export const getThumbsUp = (defaultValue) => {
  const stored = sessionStorage.getItem("thumbsup");
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
};

export const getThumbsDown = (defaultValue) => {
  const stored = sessionStorage.getItem("thumbsdown");
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
};

export const setThumbsUp = () => {
  sessionStorage.setItem("thumbsup", JSON.stringify(true));
  sessionStorage.setItem("thumbsdown", JSON.stringify(false));
};

export const setThumbsDown = () => {
  sessionStorage.setItem("thumbsup", JSON.stringify(false));
  sessionStorage.setItem("thumbsdown", JSON.stringify(true));
};

export const resetFastFeedback = () => {
  sessionStorage.setItem("thumbsup", JSON.stringify(false));
  sessionStorage.setItem("thumbsdown", JSON.stringify(false));
};
